import { ApiBackClient, ApiADA } from '../../../services/apiADA';

export function autenticarUsuarioCliente(user, password) {
    return new Promise((resolve, reject) => {
        ApiBackClient.post("/sessions", { "username": `${user}`, "password": `${password}` }, {baseURL: localStorage.getItem("base_url") })
            .then(res => {
                if (res.data === '') {
                    console.error(res.data)
                    reject({ cod: 1, error: "Retorno inválido do sistema!" });
                } else {
                    //console.log(res.data)
                    resolve(res.data);
                }
            })
            .catch(function (error) {
                if (error.response) {
                    // Requisição feita e o servidor retornou um erro
                    console.error(error.response.data);
                    console.error(error.response.status);
                    console.error(error.response.headers);
                } else if (error.request) {
                    // A requisição foi feita, mas nenhuma resposta foi recebida
                    console.error(error.request);
                } else {
                    // Alguma coisa aconteceu nas configurações da requisição que gerou um erro
                    console.error('Error', error.message);
                }
                if (error.response !== undefined && error.response.data !== undefined && error.response.data.error !== undefined) {
                    reject({ cod: 1, error: error.response.data.error });
                } else {
                    reject({ cod: 1, error: error });
                }
            });
    });
}

export function buscarBaseURL(codCliente) {

    return new Promise((resolve, reject) => {
        //resolve("https://api-pedidosforce-unified.geraldoaraujo.com.br/");

        //http://teste.geraldoaraujo.com.br:3690
        
        ApiADA.post("/public/integrador/", { "cod_cliente": codCliente })
            .then(response => {
                if (response.data?.status_cliente === "01") {
                    resolve({
                        base_url: response.data.base_url
                    })
                } else {
                    reject({
                        message: "Cliente não autorizado"
                    })
                }
            })
            .catch(err => {
                console.log(err);
                if (err.response?.status === 400 || err.response?.status === 404) {
                    reject({
                        message: "Código do cliente inválido"
                    })
                }else{
                    reject({message: "Falha ao realizar login"});
                }
            });
        
    })
}

export function Sair() {
    return new Promise((resolve) => {
        resolve({
            usuario: null
        })
    })
}
